// User-visible texts of the account and game creation pages, by tag (SPEC.md §14 text table).
import { seats } from './players';

const zh = {
  'button-place-stone': '落子',
  'notify-opponent-not-sent': '落子成功，但对手暂时无法接收微信通知',
  'notify-opponent-failed': '落子成功，但微信通知未能发出',
  'notify-opponent-unconfirmed': '落子成功，但无法确认微信通知是否送达',
  'presence-here': '正在看这盘棋',
  'presence-away': '不在',
  'app-name': '慢棋',
  'home-sign-in-link': '登录',
  'home-register-link': '注册',
  'home-tagline': '和朋友慢慢下围棋',
  'home-no-icp': '没有ICP证书!',
  'sign-in-title': '登录',
  'sign-in-forgot-link': '忘记密码？',
  'sign-in-required': '请先登录',
  'register-title': '注册',
  'forgot-title': '找回密码',
  'account-title': '我的账号',
  'field-email': '邮箱',
  'field-display-name': '昵称',
  'field-password': '密码',
  'field-password-again': '再次输入密码',
  'field-current-password': '当前密码',
  'field-new-password': '新密码',
  'field-code': '验证码',
  'button-sign-in': '登录',
  'button-register': '注册',
  'button-verify': '验证',
  'button-send-code': '发送验证码',
  'button-set-password': '设置密码',
  'button-sign-out': '退出登录',
  'button-save': '保存',
  'register-code-sent': '验证码已发送到{email}，请查收邮件',
  'register-expired': '注册已失效，请重新注册',
  'forgot-code-sent': '如果该邮箱已注册，验证码已发送',
  'reset-expired': '本次找回密码已失效，请重新发送验证码',
  'register-done': '注册已完成，请登录',
  'reset-done': '密码已重设，请用新密码登录',
  'account-change-password': '修改密码',
  'account-display-name-saved': '昵称已保存',
  'account-password-changed': '密码已修改',
  'account-no-email': '未设置',
  'seat-empty': '—',
  'seat-you': '你',
  'error-invalid-email': '邮箱格式不正确',
  'error-invalid-display-name': '昵称须为1至20个字符',
  'error-display-name-taken': '该昵称已被使用',
  'error-invalid-password': '密码须为8至72个字符',
  'error-passwords-differ': '两次输入的密码不一致',
  'error-wrong-credentials': '邮箱或密码错误',
  'error-wrong-password': '当前密码错误',
  'error-too-many-attempts': '尝试次数过多，请稍后再试',
  'error-too-soon': '操作过于频繁，请稍后再试',
  'error-invalid-code': '验证码错误',
  'error-mail-unavailable': '暂不支持注册和找回密码，请联系管理员',
  'error-mail-failed': '邮件发送失败，请稍后再试',
  'list-tab-mine': '我的棋局',
  'list-tab-all': '全部棋局',
  'list-your-move': '轮到你下',
  'create-title': '新棋局',
  'create-board-size': '棋盘',
  'create-colour': '我执',
  'create-colour-black': '黑',
  'create-colour-white': '白',
  'create-colour-nigiri': '猜先',
  'create-opponent-invite': '用链接邀请好友',
  'button-choose-opponent': '选择对手',
  'nav-back-step': '上一步',
  'create-summary': '{grid}路，{colour}',
  'create-summary-handicap': '{grid}路，{handicap}，{colour}',
  'create-handicap': '让子',
  'create-handicap-none': '不让子',
  'create-handicap-note': '黑方先摆好 {n} 子，白方先下。不贴子，终局黑方还 {half} 子。',
  'create-handicap-note-first': '黑方先下，不贴子。',
  'handicap-first': '让先',
  'handicap-stones': '让{n}子',
  'invitation-ready-title': '邀请已创建',
  'invitation-waiting-title': '邀请中 · 还剩 {days} 天',
  'invitation-expires': '{date} 到期，好友接受后棋局自动开始',
  'invitation-settings': '{grid}路，{colour}',
  'invitation-settings-handicap': '{grid}路，{handicap}，{colour}',
  'invitation-colour-black': '你执黑',
  'invitation-colour-white': '你执白',
  'button-invitation-copy-link': '复制链接',
  'invitation-link-copied': '链接已复制，发给好友吧',
  'button-invitation-share': '分享',
  'button-invitation-withdraw': '撤回邀请',
  'invitation-withdraw-confirm': '撤回后此链接失效，确定吗？',
  'invitation-withdrawn': '邀请已撤回',
  'invitation-title': '{name} 邀请你下一盘棋',
  'button-accept': '接受邀请',
  'invitation-taken': '这个邀请已被其他人接受',
  'invitation-unavailable': '邀请已过期或已撤回，请让对方重新邀请',
  'list-invitations': '我发出的邀请',
  'list-invitation-waiting': '等好友接受',
  'list-invitation-left': '还剩 {days} 天',
  'list-invitation-copy': '复制链接',
  'list-section-your-move': '轮到你下',
  'list-section-waiting': '等对方下',
  'list-section-in-progress': '进行中',
  'list-section-finished': '已结束',
  'list-waiting-for': '等{name}下',
  'list-move-number': '第{n}手',
  'list-grid': '{grid}路',
  'list-more': '向下滑动查看更多 · 还有 {n} 盘',
  'list-end': '没有更多了',
  'list-empty': '还没有棋局',
  'time-just-now': '刚刚',
  'time-minutes-ago': '{n}分钟前',
  'time-hours-ago': '{n}小时前',
  'time-days-ago': '{n}天前',
  'nav-back-to-list': '返回列表',
  'nav-list': '棋局',
  'nav-new': '+ 新棋局',
  'game-your-move': '轮到你下',
  'game-waiting-for': '等{name}下',
  'game-number': '棋局 {id}',
  'replay-position': '第 {n} 手 / 共 {total} 手',
  'replay-reset': '重置',
  'replay-back-5': '上5步',
  'replay-back-1': '上1步',
  'replay-forward-1': '下1步',
  'replay-forward-5': '下5步',
  'replay-last': '最后',
  'replay-study': '试下',
  'replay-end-study': '结束试下',
  'replay-save-variation': '保存变化',
  'study-ai-move-lost': '第{n}手 {color} {point}：比 AI 首选 {best} 亏 {points} 目',
  'study-ai-move-best': '第{n}手 {color} {point}：AI 也下这里',
  'study-ai-move-good': '第{n}手 {color} {point}：只亏 {points} 目',
  'study-ai-reply': '第{n}手 AI 下 {color} {point} · {lead}',
  'study-ai-reply-pass': '第{n}手 AI 停一手 · {lead}',
  'study-ai-manual': '手动',
  'study-ai-auto': 'AI 自动',
  'study-ai-play': 'AI 下{color}',
  'study-ai-thinking': 'AI 在想{color}棋',
  'study-ai-continue': '继续',
  'study-position': '第 {n} 手后 · 试下 {k} 手',
  'study-ai-group': '{color}方',
  'study-from-line': '试下 · 从 {line} 第 {n} 手开始',
  'study-ai-ask': '轮{color}下：点棋盘下{color}棋，或按 AI 下{color}',
  'ai-offline': 'AI 现在不在线，没能应这一手',
  'ai-offline-hint': '可以继续自己摆两边，或稍后再让 AI 下',
  'ai-busy': 'AI 正忙，请稍后再试',
  'ai-timeout': 'AI 没有及时回应',
  'ai-failed': 'AI 没能下：{reason}',
  'ai-retry': '再试一次',
  'line-study': '试下',
  'practise-study': '试下',
  'replay-rematch': '再来一局',
  'setting-sound': '音效',
  'setting-play-mode': '落子方式',
  'setting-coordinates': '显示坐标',
  'setting-padding': '棋盘边距',
  'setting-coords-font': '坐标字体',
  'setting-move-numbers': '显示手数',
  'setting-mark-font': '手数字体',
  'setting-mark-bold': '手数粗体',
  'setting-last-move-shape': '最后一手标记',
  'setting-last-move-colour': '标记颜色',
  'value-on': '开',
  'value-off': '关',
  'value-play-button': '按钮',
  'value-play-quick': '快速',
  'value-hidden': '不显示',
  'value-one-side': '单侧',
  'value-both-sides': '双侧',
  'value-last-move': '最后一手',
  'value-last-5': '最后5手',
  'value-last-10': '最后10手',
  'value-all': '所有',
  'value-normal': '正常',
  'value-bold': '加粗',
  'value-triangle': '三角',
  'value-circle': '圆圈',
  'value-red': '红色',
  'value-inverse': '反色',
  'nav-settings': '设置',
  'game-actions': '棋局操作',
  'nav-count': '数子',
  'nav-resign': '认输',
  'nav-take-back-for-opponent': '帮对手悔棋',
  'nav-delete-game': '删除棋局',
  'nav-download-sgf': '下载SGF',
  'take-back-confirm': '确定要帮对手悔棋吗?',
  'guard-not-in-game': '未在游戏中，不能操作',
  'guard-not-your-turn': '不该你走，不能操作',
  'resign-confirm': '确定要认输吗?',
  'count-failed': '数子失败: {reason}',
  'count-result-confirm': '确认数子结果',
  'count-result-score': '{color}胜 {margin} 子（黑 {black} 子，黑贴 {komi} 子）',
  'count-result-score-handicap': '{color}胜 {margin} 子（黑 {black} 子，还 {n} 子）',
  'count-result-draw': '和棋（黑 {black} 子，还 {n} 子）',
  'count-result-score-first': '{color}胜 {margin} 子（黑 {black} 子）',
  'count-result-draw-first': '和棋（黑 {black} 子）',
  'status-win-by-count': '{color}胜{margin}子',
  'status-win-by-resign': '{color}中盘胜',
  'status-draw': '和棋',
  'error-invalid-action': '无效动作{reason}',
  'reason-not-in-progress': ':游戏不在进行中',
  'reason-invalid-stone': ':棋子不正确',
  'reason-no-more-stones': ':没有棋子了',
  'reason-invalid-data': ':数据不正确',
  // Sealed moves (封手, plan 2026-10-29-sealed-moves.md).
  'reason-sealed': ':已封手，请先继续对局',
  'nav-seal': '封手',
  'game-sealing': '封手',
  'seal-hint': '选一点作为封手。封手后对方和观众都看不到，双方同意继续后才公开。',
  'button-seal': '封手',
  'button-seal-cancel': '取消封手',
  'game-sealed-own': '你已封手',
  'game-sealed-by': '{name}已封手',
  'sealed-own': '你的封手：棋盘上带“封”字的子，只有你看得到',
  'sealed-other': '封手要等双方同意继续后才公开',
  'button-resume-request': '请求继续',
  'resume-requested': '已请求继续，等{name}同意',
  'button-resume-withdraw': '取消请求',
  'resume-request-from': '{name}请求继续。同意后公开你的封手，轮到对方下。',
  'resume-request-from-other': '{name}请求继续。同意后公开{name}的封手，轮到你下。',
  'button-resume-accept': '同意继续',
  'guard-sealed': '已封手，继续对局后才能操作',
  'list-sealed-own': '你已封手',
  'list-sealed-other': '对方已封手',
  'list-resume-asked': '对方请求继续',
  'list-resume-sent': '已请求继续',
  'replay-sealed': '封手',
  'game-not-found': '找不到棋局{id}',
  'settings-title': '设置',
  'button-estimate': '形势判断',
  'load-failed': '加载失败: {reason}',
  'create-opponent': '对手',
  'create-opponent-filter': '输入昵称筛选',
  'create-opponent-self': '自己（黑白都下）',
  'create-opponent-ai': 'AI',
  'create-ai-level': '棋力',
  'ai-level-kyu': '{n}级',
  'ai-level-dan': '{n}段',
  'ai-level-max': '最强',
  'ai-player-name': 'AI {level}',
  'ai-game-slow': 'AI 还没有应：它可能暂时不在线，回来后会接着下。',
  'ai-count-request': 'AI 认为棋已下完，请求数子',
  'error-ai-not-allowed': '这个账号还不能和 AI 下棋',
  'button-create': '开始对局',
  'error-choose-opponent': '请选择对手',
  'error-invalid-settings': '设置不正确',
  'error-game-started': '对局已经开始，不能删除',
  'delete-game-confirm': '确定要删除这盘棋吗?',
  'test-site-banner': '测试环境',
  'page-loading': '加载中…',
  'button-confirm': '确认',
  'dialog-cancel': '取消',
  'admin-title': '管理',
  'field-admin-password': '管理密码',
  'admin-unavailable': '未开启管理功能',
  'admin-sign-out': '退出管理',
  'admin-games': '棋局',
  'admin-set-players': '设置对局者',
  'admin-delete-game': '删除',
  'admin-delete-confirm': '棋局{id}已有棋步，删除后无法恢复。请输入棋局编号确认：',
  'admin-accounts': '账号',
  'admin-change-email': '修改邮箱',
  'admin-saved': '已保存',
  'admin-user-disabled': '已停用',
  'admin-disable-user': '停用',
  'admin-enable-user': '启用',
  'admin-user-ai': 'AI 试下',
  'admin-ai-on': '开启 AI 试下',
  'admin-ai-off': '关闭 AI 试下',
  'admin-user-ai-games': 'AI 对局',
  'admin-ai-games-on': '开启 AI 对局',
  'admin-ai-games-off': '关闭 AI 对局',
  'admin-delete-user': '删除账号',
  'admin-delete-user-confirm': '确定要删除{name}的账号吗？删除后无法恢复。',
  'error-user-has-games': '该账号有棋局，不能删除',
  'error-account-disabled': '该账号已被停用，请联系管理员',
  'admin-sign-out-user': '退出所有登录',
  'admin-sign-out-user-confirm': '确定要让{name}在所有设备上退出登录吗？',
  'admin-signed-out': '已退出登录',
  'admin-games-search': '搜索棋局编号或对局者',
  'admin-accounts-search': '搜索名字、邮箱或编号',
  'admin-filter-all': '全部',
  'admin-filter-playing': '对局中',
  'admin-filter-empty': '空局',
  'admin-filter-done': '已结束',
  'admin-status-empty': '空局',
  'admin-moves': '{n} 手',
  'admin-analysis-full': '已分析',
  'admin-analysis-partial': '部分分析',
  'admin-analysis-old': '旧版分析',
  'admin-analysis-none': '未分析',
  'admin-col-id': '编号',
  'admin-col-status': '状态',
  'admin-col-moves': '手数',
  'admin-col-players': '对局者',
  'admin-col-name': '名字',
  'admin-col-email': '邮箱',
  'admin-col-games': '棋局',
  'admin-user-games': '棋局 {n}',
  'admin-games-player': '对局者：{name}',
  'admin-games-player-clear': '显示全部棋局',
  'admin-no-match': '没有符合条件的项目',
  'error-email-taken': '该邮箱已被其他账号使用',
  'color-black': '黑',
  'color-white': '白',
  'chart-winrate': '黑胜率 {rate}%',
  'chart-lead': '{color}领先 {points} 目',
  'chart-even': '均势',
  'chart-switch-to-lead': '看领先目数',
  'chart-switch-to-winrate': '看胜率',
  'analysis-move-lost': '第{n}手 {color} {point}：损失 {points} 目',
  'analysis-move-best': '第{n}手 {color} {point}：AI 首选',
  'analysis-move-none': '第{n}手 {color} {point}',
  'analysis-move-pass': '第{n}手 {color} 停一手',
  'analysis-best-pass': '（推荐停一手）',
  'suggestions-hide': '隐藏推荐',
  'suggestions-show': '显示推荐',
  'analysis-none': '这盘棋还没有分析',
  'analysis-request': '分析这盘棋',
  'analysis-requested': '已请求分析，完成后图表会出现在这里',
  'analysis-request-failed': '请求分析失败：{reason}',
  'reason-not-completed': '棋局尚未结束',
  'analysis-line-hint': '点推荐点的数字，看 AI 预想的后续变化',
  'analysis-line': 'AI 推荐 {rank}：{color} {point} 起 {n} 手 · {lead}',
  'analysis-line-short': 'AI 只细算到这里',
  'analysis-line-step': '变化第 {n} / {total} 手',
  'analysis-line-back': '返回对局',
  'analysis-line-switch': '推荐 {rank} / {shown}',
  'analysis-line-prev': '上一个推荐',
  'analysis-line-next': '下一个推荐',
  'mistake-prev': '‹ 上个失误',
  'mistake-next': '下个失误 ›',
  'analysis-compare': '对比学习',
  'compare-tab-actual': '实战 {point} 之后',
  'compare-tab-suggested': '推荐 {point} 之后',
  'compare-tab-both': '对比',
  'compare-actual': '实战下 {point}，AI 预想的变化共 {n} 手 · {lead}',
  'compare-suggested': 'AI 推荐下 {point}，变化共 {n} 手 · {lead}',
  'compare-both': '{best} 比 {played} 多得 {points} 目',
  'compare-legend-black': '黑多得',
  'compare-legend-white': '白多得',
  'compare-legend-step': '：变化第 {n} 手之后的结局，和第{p}手比',
  'compare-legend-best': '只有推荐 {point} 得到',
  'compare-legend-played': '只有实战 {point} 得到',
  'label-dies': '{where}{color} {n} 子会被吃',
  'label-lives': '{where}{color} {n} 子活了',
  'label-answer-local': '推荐在对方上一手附近应，实战下在了别处',
  'label-tenuki': '推荐脱先下在别处，实战在对方上一手附近应了',
  'region-top-left': '左上角',
  'region-top': '上边',
  'region-top-right': '右上角',
  'region-left': '左边',
  'region-centre': '中腹',
  'region-right': '右边',
  'region-bottom-left': '左下角',
  'region-bottom': '下边',
  'region-bottom-right': '右下角',
  'estimate-katago': 'AI 形势判断：{lead}',
  'estimate-katago-open': '没有方块的地方：还说不定',
  'estimate-waiting': 'AI 正在判断…',
  'practise': '练习模式',
  'practise-progress': '练习 {n} / {total} · 你的第 {k} 个失误',
  'practise-progress-both': '练习 {n} / {total} · {color}的第 {k} 个失误',
  'practise-done': '练习完了',
  'practise-question': '第{n}手 轮{color}下 · 实战 {point}（圈）损失 {points} 目',
  'practise-ask': '点一下棋盘：你现在会下哪里？',
  'practise-answer': '看答案',
  'practise-skip': '跳过 ›',
  'practise-prev': '‹ 上一题',
  'practise-back-question': '‹ 返回题目',
  'practise-not-yet': '{point}：比实战好 {better} 目，比 AI 首选差 {worse} 目',
  'practise-worse': '{point}：还不如实战，多损失 {points} 目',
  'practise-same': '{point}：这就是实战下的',
  'practise-again': '再试一次',
  'practise-best': '{point}：好棋！正是 AI 的首选',
  'practise-good': '{point}：好棋！只比 AI 首选少 {points} 目',
  'practise-next': '下一题 ›',
  'practise-count': '{total} 个失误里，{found} 个找到了好棋（{first} 个第一次就找到）',
  'practise-row-first': '第{n}手 {played}：找到 {point} ✓',
  'practise-row-later': '第{n}手 {played}：第{k}次找到 {point} ✓',
  'practise-row-shown': '第{n}手 {played}：看了答案',
  'practise-row-skipped': '第{n}手 {played}：跳过了',
  'practise-restart': '再练一遍',
  'practise-back': '返回对局',
  'practise-end': '结束练习',
  'practise-more': '显示全部',
  'practise-dismissed': '{point}：AI 一眼就排除了这一手，多半不好',
  'practise-unknown': '{point}：AI 没细算这一手，说不准好坏',
  'practise-hint-far': '它的首选不在这一带：再找找？',
  'practise-hint-near': '它的首选就在这一带：再找找？',
  // The game chat (SPEC §5.6).
  'button-chat': '聊天',
  'chat-title': '聊天',
  'chat-spectator': '（观众）',
  'chat-move': '第{n}手',
  'chat-new': '新消息',
  'chat-placeholder': '说点什么…',
  'button-chat-send': '发送',
  'chat-emoji-open': '表情',
  'chat-keyboard-open': '键盘',
  'chat-emoji-delete': '删除',
  'chat-phrase-1': '休战',
  'chat-phrase-2': '晚点下',
  'chat-phrase-3': '我要考虑一下',
  'chat-phrase-4': '好棋！',
  'chat-empty': '还没有人说话',
  'chat-send-failed': '没发出去，点这里重发',
  'chat-load-failed': '聊天记录没读到，点这里重试',
  'chat-close': '关闭',
  'chat-bubble': '{name}发来新消息',
  'chat-bubble-spectators': '观众发来新消息',
  'chat-bubble-text': '新',
  'chat-time-yesterday': '昨天 {time}',
  'chat-time-date': '{month}月{day}日 {time}',
  'error-chat-empty': '不能发空消息',
  'error-chat-too-long': '最多 500 字',
  'error-chat-too-fast': '发得太快了，等一下再发',
};

// Modules add their own texts and error codes (DESIGN.md, Integrations).
export function addTexts(texts, errors = {}) {
  Object.assign(zh, texts);
  Object.assign(errorTags, errors);
}

// t('register-code-sent', { email }) returns the text with its placeholders filled in.
export function t(tag, params = {}) {
  let s = zh[tag];
  if (s === undefined) return tag;
  for (const k in params) s = s.split(`{${k}}`).join(params[k]);
  return s;
}

// Text for an error code of the API (the envelope's message).
const errorTags = {
  'invalid-email': 'error-invalid-email',
  'invalid-display-name': 'error-invalid-display-name',
  'display-name-taken': 'error-display-name-taken',
  'invalid-password': 'error-invalid-password',
  'wrong-credentials': 'error-wrong-credentials',
  'wrong-password': 'error-wrong-password',
  'too-many-attempts': 'error-too-many-attempts',
  'too-soon': 'error-too-soon',
  'invalid-code': 'error-invalid-code',
  'mail-unavailable': 'error-mail-unavailable',
  'mail-error': 'error-mail-failed',
  'invalid-settings': 'error-invalid-settings',
  'game-started': 'error-game-started',
  'email-taken': 'error-email-taken',
  'user-has-games': 'error-user-has-games',
  'account-disabled': 'error-account-disabled',
  'admin-unavailable': 'admin-unavailable',
  'not-completed': 'reason-not-completed',
  'chat-empty': 'error-chat-empty',
  'chat-too-long': 'error-chat-too-long',
  'chat-too-fast': 'error-chat-too-fast',
};

export function errorText(code) {
  return errorTags[code] ? t(errorTags[code]) : code;
}

// The players of a game: #color-black:name #color-white:name, with #seat-empty for a colour
// nobody plays (the owner chose plain colour tags over one combined text, 2026-10-19).
export function seatLabel(colour) {
  return t(colour === 'white' ? 'color-white' : 'color-black') + ':';
}
export function playersText(game) {
  const { black, white } = seats(game);
  const name = p => (p && p.displayName) || t('seat-empty');
  return `${seatLabel('black')}${name(black)} ${seatLabel('white')}${name(white)}`;
}
